import { render } from "./EditFacturePage.vue?vue&type=template&id=ff0d1e9c&ts=true"
import script from "./EditFacturePage.vue?vue&type=script&lang=ts"
export * from "./EditFacturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__